import React from "react";
import { object, array } from "prop-types";
import HeroImage from "../../atoms/heroImage";
import StoryHeadline from "../../atoms/story-headline";
import "./titleAboveHeroImage.m.css";

const TitleAboveHeroImage = ({ story, width }) => (
  <div styleName="wrapper">
    <HeroImage story={story} width={width} />
    <StoryHeadline story={story} aboveHeroImage />
  </div>
);

TitleAboveHeroImage.propTypes = {
  story: object,
  width: array
};

export default TitleAboveHeroImage;
